<style scoped>
    .id-card-img{
        max-width: 360px;
    }
</style>
<template>
    <div>
        <Table border stripe size="small" :columns="career_columns" :data="customer.careers"></Table>
        <div class="line">
            <div>
                <span class="text-bold">身份证正面</span>
                <a :href="id_front_src" :download="id_front_name" v-if="id_front_src">下载</a>
            </div>
            <img class="id-card-img" :src="id_front_src" v-if="id_front_src">
            <span v-else>未上传</span>
        </div>
        <div class="line">
            <div>
                <span class="text-bold">身份证反面</span>
                <a :href="id_back_src" :download="id_back_name" v-if="id_back_src">下载</a>
            </div>
            <img class="id-card-img" :src="id_back_src" v-if="id_back_src">
            <span v-else>未上传</span>
        </div>
        <div class="line">
            <div>
                <span class="text-bold">学生证照片</span>
                <a :href="student_card_src" :download="student_card_name" v-if="student_card_src">下载</a>
            </div>
            <img class="id-card-img" :src="student_card_src" v-if="student_card_src">
            <span v-else>未上传</span>
        </div>
        <div class="line">
            <div>
                <span class="text-bold">银行卡照片</span>
                <a :href="bank_card_src" :download="bank_card_name" v-if="bank_card_src">下载</a>
            </div>
            <img class="id-card-img" :src="bank_card_src" v-if="bank_card_src">
            <span v-else>未上传</span>
        </div>
    </div>
</template>
<script>
    import Util from '../../../libs/util';
    export default {
        props: ['customer'],
        data () {
            return {
                career_columns: [
                    {
                        title: '序号',
                        width: 50,
                        align: 'center',
                        render: (h, params)=>{
                            return h('div', params.index+1);
                        }
                    },
                    {
                        title: '合同开始',
                        key: 'contract_start',
                        align: 'center',
                    },
                    {
                        title: '合同结束',
                        key: 'contract_end',
                        align: 'center',
                    },
                    {
                        title: '离职时间',
                        key: 'quit_time',
                        align: 'center',
                    },
                    {
                        title: '备注',
                        key: 'desc',
                        align: 'center',
                    }
                ]
            }
        },
        computed: {
            id_front_src(){
                return this.customer.id_front ? Util.customerFileUrl(this.customer.id_front) : '';
            },
            id_back_src(){
                return this.customer.id_back ? Util.customerFileUrl(this.customer.id_back) : '';
            },
            student_card_src(){
                return this.customer.student_card ? Util.customerFileUrl(this.customer.student_card) : '';
            },
            bank_card_src(){
                return this.customer.bank_card ? Util.customerFileUrl(this.customer.bank_card) : '';
            },
            id_front_name(){
                return `${this.customer.account}_正面`;
            },
            id_back_name(){
                return `${this.customer.account}_反面`;
            },
            student_card_name(){
                return `${this.customer.account}_学生证照片`;
            },
            bank_card_name(){
                return `${this.customer.account}_银行卡照片`;
            }
        },
        created(){
            //
        },
        mounted(){
            //
        },
        methods: {
            //
        }
    }
</script>
